import React, { FC } from 'react';
import {
  useBreakpoint,
} from '@printdeal/ui-library';
import useSystemPages from '../../../hooks/useSystemPages';
import MobileCustomerCareNavigation from './MobileCustomerCareNavigation';
import DesktopCustomerCareNavigation from './DesktopCustomerCareNavigation';

const ResellerCustomerCareNavigation: FC = () => {
  const [helpCenterPage] = useSystemPages('helpCenterIndex');
  const { title, path } = helpCenterPage;

  const isMobile = useBreakpoint('max-lg');

  if (isMobile) {
    return (
      <MobileCustomerCareNavigation
        title={title}
        path={path}
      />
    );
  }

  return <DesktopCustomerCareNavigation />;
};

export default ResellerCustomerCareNavigation;
